var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"inline-block w-full",style:({ opacity: _vm.opacity }),attrs:{"src":require(("@/assets/icons/" + _vm.name)),"alt":"icon"}})}
var staticRenderFns = []

export { render, staticRenderFns }